/**
 * تكوين موحَّد لمساعد Lecmo:
 * - مفاتيح sessionStorage (مكان واحد لتسهيل المسح/التغيير)
 * - رقم واتساب الكونسيرج
 * - أوقات الفقّاعة الترحيبيّة
 *
 * كلّ مكان آخر في الشيفرة يستورد من هنا — لا تُكتب القيم الحرفيّة في مكانين.
 */

// رقم WhatsApp الرسميّ — يُغيَّر هنا فقط
export const LECMO_WA_NUMBER = "971508877701";

// مفاتيح sessionStorage — كلّها مسبوقة بـ"lecmo-agent-"
export const AGENT_STORAGE_KEYS = {
  open: "lecmo-agent-open",
  bubbleDismissed: "lecmo-agent-bubble-dismissed",
  bubbleDismissedAt: "lecmo-agent-bubble-dismissed-at",
  openedOnce: "lecmo-agent-opened",
  history: "lecmo-agent-history-v1",
} as const;

// مهلة ظهور فقّاعة الترحيب لأوّل مرّة
export const BUBBLE_DELAY_MS = 5000;

// إعادة عرض الفقّاعة بعد إغلاقها — تذكير لطيف
export const BUBBLE_REAPPEAR_MS = 10 * 60 * 1000;

// مدّة بقاء الفقّاعة على الشاشة قبل اختفائها تلقائياً
export const BUBBLE_AUTO_HIDE_MS = 8000;

// قراءة آمنة من sessionStorage (تحمي من SSR ومن متصفّحات الخصوصيّة)
export function readSession(key: string): string | null {
  if (typeof window === "undefined") return null;
  try {
    return window.sessionStorage.getItem(key);
  } catch {
    return null;
  }
}

// كتابة آمنة لـsessionStorage
export function writeSession(key: string, value: string): void {
  if (typeof window === "undefined") return;
  try {
    window.sessionStorage.setItem(key, value);
  } catch {
    /* private mode أو حصّة ممتلئة — تجاهل */
  }
}

/** يمسح كلّ بيانات المساعد من الجلسة الحاليّة. */
export function clearAgentSession(): void {
  if (typeof window === "undefined") return;
  try {
    for (const k of Object.values(AGENT_STORAGE_KEYS)) {
      window.sessionStorage.removeItem(k);
    }
  } catch {
    /* ignore */
  }
}
